export const locale = {
  lang: 'es',
  data: {
    'LANDINFOCUS': {
      'ENCUESTAS':{
        'TITULO':'Este es un proceso de Focus Area',
        'NO-ENCU':'Actualmente no cuentas con un proceso de encuesta asignada',
        'ENC-AUTO':'Encuesta Autorizada',
        'ENC-CORRECI':'La encuesta se envio a corrección',
        'MODAL_NO_COLAB_EMPRE':'Aún no ha subido su base de colaboradores,¿Está seguro de continuar?',


      },
      'STATUS-ENCUESTA':{
        '1':'En proceso',
        '2':' Evaluar',
        '3':' Autorizada',
        '5':'Corregir',

      },
      'LISTA': {
        'TAB': 'Lista de colaboradores',
        'BUSCAR': {
          'INFO': 'Puede buscar uno o más colaboradores de la lista escribiendo el nombre a continuación',
          'PLACEHOLDER': 'Buscar colaborador'
        },
        'AGREGAR': {
          'BOTON': 'Agregar colaborador'
        },
        'TABLA': {
          'COLUMNAS': {
            'NOMBRE': 'Nombre completo',
            'EMAIL': 'Correo electrónico',
            'ACCIONES': 'Acciones disponibles'
          }
        },
        'TOOLTIPS': {
          'AGREGAR': 'Agregar un colaborador a la lista',
          'EDITAR': 'Editar datos del colaborador'
        }
      },
      'MODALES':{
        'CREARENC': 'Introduzca el nombre de la encuesta',
        'DELETE': 'Realmente quieres eliminar',
        'CORRECTO': ' Se agrego correctamente ',
        'COMDELETE': 'Correctamente removido',
        'RSPSI':'SI',
        'RSPNO':'NO',
        'RSPOK':'OK',
        'RSPACEPTAR':'Aceptar',
        'CARGANDOLISTA': 'Recuperando la lista de colaboradores, espere un momento'
      },
      'WIZARD':{
        'CARGANDOF': 'Cargando productos adquiridos.',
        'SINPRODS': 'No ha adquirido este producto.',
        'CREARENC': 'Crear encuesta',
        'DONE': 'Año de aplicación: ',
        'TITULO': 'BIENVENIDO A FOCUS AREA',
        'TFOCUS': 'ENCUESTAS DE  FOCUS AREA',
        'DELETE': 'Eliminar',
        'EDIT': 'Editar',
        'VERIPRE':'Verificar preguntas',
        'AVANCE':'Avance',
        'TITUVERI':'Verificación de preguntas',
        'TITUTABTEM':'Preguntas por plantillas',
        'TITUTABADI':'Preguntas Personalizadas',
        'TITUTAUTORIZADA':'Encuesta Autorizada',
        'TITUTNOAUTORIZADA':'Desautorizar Encuesta',
        'TITUTAUTORIZAR':'Autorizar Encuesta',
        'TITUTCORREGIR':'Corregir Encuesta',

      },
      'TABLACAMPOS':{
        'NAME':'Nombre encuesta',
        'FECHAI':'Fecha inicio',
        'FECHAF':'Fecha Final',
        'AVANCE':'Avance',
        'ESTADO': 'Estado',

        'ACCION': 'Acciones',
      },
      'COLABORADORES':{
        'CARGACOLAB':'Cargar Colaboradores Certificar'
      },
      'ADMIN-PREG':{
      'TITULO-ABIE':'Preguntas abiertas',
      'PREGUN':'Preguntas',
      'PREGUNSUB':'Pregunta',
      'DESCRIP-PREGUN':'Presione aquí para visualizar la pregunta',
      'TITULO-UNAOPC':'Preguntas de una opción',
      'TITULO-MULOPC':'Preguntas de multiple opción',
      'OPC':'Opciones',
      'OPCSUB':'Opción',
      'NO-ADICI':'La encuesta no tiene preguntas Adicionales',
    },
    'IDIOM-NATIVO':{
    'pt':'Portugues',
    'es': 'Español',
    'en':'English',
  },
  'STEP_COLAB':{
    'STEP_1':{
      'TITULO_STEP_ELEGIR_COLAB':'Selección tipo de colaboradores',
      'INST_1':'Seleccione una de las siguientes opciones',
      'NUEVA_BASE_COLA':'Subir base de colaboradores nueva',
      'BASE_COLAB_EXIS':'Usar base de colaboradores principal',
      'BTN_SIGUENTE':'Siguiente',

    },
    'STEP_2':{
      'TITULO_STEP_SUBIR_COLAB':'Selección de colaboradores',
      'MAT_TITLE_DEMO_SELE':'Demograficos seleccionados',
      'ALERT_NOT_DEMO_SELE':'Aún no ha seleccionado filtros',
      'ALERT_NOT_SELE_COLAB':'Ningún colaborador agregado',
      'AGREGAR_FILTRO':'Agregar filtro',
      'TH_NOMBRE':'Nombre colaborador',
      'TH_ACCION':'Acciones',
      'INTS_SEL_1_O_MAS_COLAB':'*Nota: seleccione uno o más colaboradores',
      'SIN_RESULTADOS':'La selección actual de filtros no devolvió ningún resultado, prueba cambiando los filtros e intente nuevamente',
      'BTN_REGRESAR':'Regresar',
      'BTN_AGRE_COLAB':'Agregar colaboradores',
      'BTN_GUAR_COLAB':'Guardar colaboradores',
      'BTN_BORR_COLAB':'Borrar colaboradores',
      'BTN_ACEPTAR':'Aceptar',
      'BTN_BUSCAR':'Buscar',
      'TITULO_MODAL_DEMOGRA':'Lista de demograficos',
      'MAT_TITLE_EXPA_RESULT':'Resultados busqueda colaboradores:',
      'MAT_TITLE_EXPA_AGREG':'Colaboradores agregados:',
      'MAT_TITLE_EXPA_DESCRIP':'Ver colaboradores',
      'MODALES':{
        'MODAL_CARGAN_FILTROS':'Cargando filtros',
        'MODAL_BUSCA_COLAB':'Buscando colaboradores filtrados',
        'MODAL_AGRE_COLAB':'Agregando colaboradores',
        'MODAL_DELET_COLAB':'Elimando la información de los colaboradores',
        'MODAL_SUCCES_AGRE_COLAB':'Se agregaron los colaboradores correctamente',
        'MODAL_GUAR_COLAB':'Guardando colaboradores',
        'MODAL_CONFIR_BORRAR_COLAB':'¿Está seguro de borrar el colaborador?',
        'MODAL_CONFIR_BORRAR_COLABRES':'¿Está seguro de borrar los colaboradores?',
        'MODAL_CONFIR_GUAR_COLAB_BACK':'¿Está seguro de guardar los  colaboradorres agregados?',
        'MODAL_SUCCES_GUAR_COLAB':'Se guardaron los colaboradores correctamente',
        'MODAL_SUCCES_BORRA_COLAB':'Se borro colaborador correctamente',
        'MODAL_SUCCES_BORRA_COLABRES':'Se borraron los colaboradores correctamente',
        'MODAL_WARNN_NO_SELECT_COLAB':'Aún no ha seleccionado ningún colaborador',
        'BTN_SI':'Sí',
        'BTN_NO':'No',
        'BTN_OK':'Ok',
      },
      'FORMULARIO':{
        'fullName': 'Nombre del colaborador',
        'ownKey': 'Número / Clave del colaborador',
        'age': 'Año de nacimiento',
        'surveyKey': 'Clave para ingresar a la encuesta',
        'email': 'Correo electrónico',
        'bossName': 'Nombre del Jefe directo',
        'bossKey': 'Número / Clave Jefe directo',
        'country': 'País',
        'location': 'Localidad',
        'geo_1': 'Nivel geográfico 1',
        'geo_2': 'Nivel geográfico 2',
        'geo_3': 'Nivel geográfico 3',
        'geo_4': 'Nivel geográfico 4',
        'geo_5': 'Nivel geográfico 5',
        'geo_6': 'Nivel geográfico 6',
        'geo_7': 'Nivel geográfico 7',
        'geo_8': 'Nivel geográfico 8',
        'geo_9': 'Nivel geográfico 9',
        'geo_10': 'Nivel geográfico 10',
        'structure_1': 'Nivel estructural 1',
        'structure_2': 'Nivel estructural 2',
        'structure_3': 'Nivel estructural 3',
        'structure_4': 'Nivel estructural 4',
        'structure_5': 'Nivel estructural 5',
        'structure_6': 'Nivel estructural 6',
        'structure_7': 'Nivel estructural 7',
        'structure_8': 'Nivel estructural 8',
        'structure_9': 'Nivel estructural 9',
        'structure_10': 'Nivel estructural 10',
        'area': 'Área',
        'bUnit': 'Unidad de negocio',
        'enterDate': 'fecha de ingreso (dd/mm/aaaa)',
        'antiquity': 'Antigüedad',
        'antiquityUS': 'Antigüedad US',
        'generation': 'Generación',
        'generationUS': 'Generación US',
        'ageUS': 'Edad',
        'charge': 'Cargo o función en la Empresa',
        'homologado': 'Cargo o función homologado',
        'homologadoUS': 'Cargo o función homologado US',
        'gender': 'Género',
        'genderType': 'Tipo de género',
        'typeofwork': 'Esquema de compensación',
        'workCondition': 'Condición de trabajo',
        'academico': 'Grado académico',
        'contratacion': 'Tipo de contratación',
        'situacionUS': 'Situación laboral US',
        'personal': 'Tipo de personal',
        'jornada': 'Tipo de jornada de trabajo',
        'rotacion': 'Rotación de turnos',
        'phone': 'Teléfono',
        'extension': 'Extensión',
        'cellphone': 'Número de celular',
        'native': 'Idioma materno',
        'answer': 'Responde',
        'other_1': 'Otros 1',
        'other_2': 'Otros 2',
        'other_3': 'Otros 3',
        'other_4': 'Otros 4',
        'other_5': 'Otros 5',
        'other_6': 'Otros 6',
        'other_7': 'Otros 7',
        'other_8': 'Otros 8',
        'other_9': 'Otros 9',
        'other_10': 'Otros 10',
      },
    },
}
}
}
};
